import "./index.scss"

function Logo() {
  return (
    <div className="logo-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="1080"
        height="793.8"
        viewBox="0 0 1080 793.8"
      >
        <g transform="matrix(1,0,0,1,-1.174334140435917,0.595141700404838)">
          <svg
            viewBox="0 0 336 247"
            data-background-color="#ffffff"
            preserveAspectRatio="xMidYMid slice"
            height="793.8"
            width="1080"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="tight-bounds"
              transform="matrix(1,0,0,1,0.1972881355932259,-0.09999999999999432)"
            >
              <svg
                viewBox="0 0 335.60542372881355 247.2"
                height="247.2"
                width="335.60542372881355"
              >
                <g>
                  <svg
                    viewBox="0 0 335.60542372881355 247.2"
                    height="247.2"
                    width="335.60542372881355"
                  >
                    <g>
                      <svg
                        viewBox="0 0 335.60542372881355 247.2"
                        height="247.2"
                        width="335.60542372881355"
                      >
                        <g id="textblocktransform">
                          <svg
                            viewBox="0 0 335.60542372881355 247.2"
                            height="247.2"
                            width="335.60542372881355"
                            id="textblock"
                          >
                            <g>
                              <svg
                                viewBox="0 0 335.60542372881355 247.2"
                                height="247.2"
                                width="335.60542372881355"
                              >
                                <g transform="matrix(1,0,0,1,0,0)">
                                  <svg
                                    width="335.60542372881355"
                                    viewBox="0.9 -29 40.050000000000004 29.5"
                                    height="247.2"
                                    data-palette-color="#ffffff"
                                  >
                                    <path
                                      d="M0.9-29L2.5-29 13.4-3.35 20.95-21.1 28.45-3.35 38.7-27.5 6.45-27.5 6.45-29 40.95-29 28.45 0.5 20.95-17.25 13.4 0.5 0.9-29Z"
                                      opacity="1"
                                      transform="matrix(1,0,0,1,0,0)"
                                      fill="#ffffff"
                                      class="wordmark-text-0"
                                      data-fill-palette-color="primary"
                                      id="text-0"
                                    ></path>
                                  </svg>
                                </g>
                              </svg>
                            </g>
                          </svg>
                        </g>
                      </svg>
                    </g>
                    <g></g>
                  </svg>
                </g>
                <defs></defs>
              </svg>
              <rect
                width="335.60542372881355"
                height="247.2"
                fill="none"
                stroke="none"
                visibility="hidden"
              ></rect>
            </g>
          </svg>
        </g>
      </svg>
    </div>
  )
}

export default Logo
